import { render, staticRenderFns } from "./radioWave.vue?vue&type=template&id=11535b3b&scoped=true"
import script from "./radioWave.vue?vue&type=script&lang=js"
export * from "./radioWave.vue?vue&type=script&lang=js"
import style0 from "./radioWave.vue?vue&type=style&index=0&id=11535b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11535b3b",
  null
  
)

export default component.exports